export const STORAGE_PROFILE = "user_profile";
export const STORAGE_ID_TOKEN = "id_token";
export const STORAGE_ACCESS_TOKEN = "access_token";
export const STORAGE_EXPIRES_AT = "expires_at";
export const STORAGE_USER_GROUPS = "user_groups";
export const STORAGE_FEEDBACK_LOOP = "feedback_loop";
